// export default function ConfirmationModal({
//   title = "Are you sure?",
//   description,
//   confirmText = "Yes, confirm",
//   cancelText = "Cancel",
//   onConfirm,
//   onCancel,
// }) {
//   return (
//     <div
//       className="fixed inset-0 z-50 flex items-center justify-center"
//       style={{ background: "rgba(0,0,0,0.45)" }}
//       onClick={onCancel}
//     >
//       <div
//         className="bg-white rounded-2xl overflow-hidden"
//         style={{ width: "min(300px, 90vw)" }}
//         onClick={(e) => e.stopPropagation()}
//       >
//         {/* Header */}
//         <div className="px-6 pt-7 pb-5 text-center">
//           <div className="w-11 h-11 rounded-full bg-[#EEF2FF] flex items-center justify-center mx-auto mb-3.5">
//             <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
//               <path
//                 d="M10 3a7 7 0 1 0 0 14A7 7 0 0 0 10 3zm0 4a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 7zm0 6.5a.875.875 0 1 1 0-1.75.875.875 0 0 1 0 1.75z"
//                 fill="#1e3a5f"
//               />
//             </svg>
//           </div>
//           <p className="font-semibold text-[15px] text-[#1e3a5f]">{title}</p>
//           {description && (
//             <p className="text-gray-500 text-[13px] mt-1.5 leading-relaxed">
//               {description}
//             </p>
//           )}
//         </div>

//         <div className="h-px bg-gray-100" />

//         {/* Buttons */}
//         <div className="flex gap-2.5 p-4">
//           <button
//             onClick={onConfirm}
//             className="flex-1 py-2 rounded-lg text-[13px] font-semibold text-white bg-[#1e3a5f] hover:bg-[#162d4a] transition-colors"
//           >
//             {confirmText}
//           </button>
//           <button
//             onClick={onCancel}
//             className="flex-1 py-2 rounded-lg text-[13px] font-semibold text-[#1e3a5f] border border-[#1e3a5f] hover:bg-[#f0f4fa] transition-colors"
//           >
//             {cancelText}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

import "./ConfirmationModal.css";

export default function ConfirmationModal({
  title = "Are you sure?",
  description,
  confirmText = "Yes, confirm",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
}) {
  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="modal-header">
          <div className="modal-icon">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                d="M10 3a7 7 0 1 0 0 14A7 7 0 0 0 10 3zm0 4a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 7zm0 6.5a.875.875 0 1 1 0-1.75.875.875 0 0 1 0 1.75z"
                fill="#1e3a5f"
              />
            </svg>
          </div>

          <p className="modal-title">{title}</p>

          {description && <p className="modal-description">{description}</p>}
        </div>

        <div className="modal-divider" />

        {/* Buttons */}
        <div className="modal-actions">
          <button onClick={onConfirm} className="modal-btn modal-confirm">
            {confirmText}
          </button>

          <button onClick={onCancel} className="modal-btn modal-cancel">
            {cancelText}
          </button>
        </div>
      </div>
    </div>
  );
}
